// extracted by mini-css-extract-plugin
export default {"logo_wrapper":"LogoWrapper_logo_wrapper__kq6rQ","logo_custom_wrapper":"LogoWrapper_logo_custom_wrapper__GGjvv"};